import { Service } from "../@types/service";
import { serviceService } from "../services";
import { withRetry } from "../utils";
import { showToast } from "../utils/toastUtils";

const BASE = `services`;

const handleError = (e: any) => {
  showToast(e.response?.data || e.message, "error");
  throw new Error(e.response?.data || e.message);
};

export const createNewService = async (data: Service) => {
  return withRetry(async () => {
    const res = await serviceService.post(`/${BASE}`, data);
    return res.data;
  }).catch(handleError);
};

export const getService = async (id: string) => {
  return withRetry(async () => {
    const res = await serviceService.get(`${BASE}/${id}`);
    return res.data;
  }).catch(handleError);
};

export const updateService = async (id: string, data: Service) => {
  return withRetry(async () => {
    const res = await serviceService.patch(`/${BASE}/${id}`, data);
    return res.data;
  }).catch(handleError);
};

export const deleteService = async (id: string) => {
  return withRetry(async () => {
    const res = await serviceService.delete(`/${BASE}/${id}`);
    return res.data;
  }).catch(handleError);
};
